<template>
<div class="text-xs-center">
  <v-btn :disabled="!active" round small block color="light-green darken-2" class="table-button center" @click="dialog=true">
    <span style="margin-right: 10px; font-weight: bold" :class="{ 'counter-active': active }">
      {{ this.location.length }}
    </span>
    <v-icon color="white">list</v-icon>
  </v-btn>
  <v-dialog v-model="dialog" width="80%">
    <v-card>
      <v-card-title class="headline" primary-title>
        {{field.name}}
      </v-card-title>

  <v-data-table :headers="headers"  :items="location" class="elevation-1">

    <template slot="items" slot-scope="props">
      <td v-for="(header, index) in headers" :key="index"  >
        <div v-if="header.value=='mode'">{{ props.item[header.value] == 1 ? "Po otwarciu formularza" : "Po wypełnieniu pola" }}</div>
        <div v-else-if="header.value=='time'">{{ DataTimeHelper.getDateTime(new Date(props.item[header.value])) }}</div>
        <div v-else-if="header.value=='userId'">{{ getUserInfo(props.item[header.value]) }}</div>
        <div v-else-if="header.value=='fieldId'">{{ getFieldInfo(props.item[header.value]) }}</div>
        <div v-else-if="header.value=='action'">
          <v-btn icon @click="goToGoogleMaps(props.item)" color="transaprent">
            <v-icon color="green">place</v-icon>
          </v-btn>
        </div>
        <div v-else>{{ props.item[header.value] }}</div>
      </td>
    </template>
  </v-data-table>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import DataTimeHelper from "../../../plugins/DataTimeHelper";

export default {
  components: {
  },
  props: ["location", "field"],
  computed: {
    DataTimeHelper() {
      return DataTimeHelper
    },
    locale: () => process.env.VUE_APP_LOCALE,
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
  },

  data() {
    return {
      dialog: false,
      active:true,
      loading: true,
      editable: false,
      headers: [
        {value: "latitude", text: "Szerokość"},
        {value: "longitude", text:"Wysokość"},
        {value: "mode", text:"Tryb"},
        {value:"time", text: "Czas"},
        {value: "userId", text:"Uzytkownik"},
        {value: "fieldId", text:"Pole"},
        {value: "action", text:"Zobacz lokalizacje"},
      ],
      pagination: this.$store.getters.pagination,
    }
  },
  methods: {
    getUserInfo(id){
      let user = this.$store.state.users.find(user => id == user.id )
      if(!user){
        return ""
      }

      return user.name + " " + user.surname
    },
    getFieldInfo(id){
      let field = this.$store.state.forms.schema.fields.find(el => el.id == id)
      if(!field)
        return "-"

      return field.name
    },
    goToGoogleMaps(location){
      let url = `http://maps.google.com?q=${location.latitude},${location.longitude}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scope>
.radio>label {
  font-size: 11px !important;
}
.counter-active {
  color: #efefef;
}

.unvalidate {
  background-color: #ff4d4d !important;
}

.table-button {
  width: 80px;
}

.imageField {
  height: 100px;
  /*transform: rotate(-90deg);*/
}

.active {
  //background-color: green !important;
}

.pretty-display {
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
  padding: 10px 24px;
}

.header {
  width: 250px;
}

.center {
  margin: 0 auto;
}
</style>
